<template>
    <l-modal :showing="showing" text="New group" icon="edit" color="bg-black" @close="close">
        <div class="w-full text-xs">
            <div class="w-full flex">
                <div class="w-full">
                    <b>Name</b>
                    <br />
                    <l-input placeholder="Name" v-model="name" inputClass="text-2xs" />
                </div>
            </div>
            <div class="w-full flex mb-4"></div>
            <div class="w-full flex mb-4">

                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Network</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="network">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Observations</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="observations">Read/Write</l-checkbox>
                    </div>
                </div>                
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Export</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="exporting">Read/Write</l-checkbox>
                    </div>
                </div>
            </div>
            <div class="w-full flex mb-4">

                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Quality control</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="qualitycontrol">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Processing</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="processing">Read/Write</l-checkbox>
                    </div>
                </div>
                <div class="w-1/3 flex mb-4">
                    <div class="w-full">
                        <b>Users</b>
                        <br />
                        <l-checkbox class="mr-4" v-model="users">Read/Write</l-checkbox>
                    </div>
                </div>
            </div>
            <div class="w-full flex mb-4">
                <div class="w-full">
                    <b>Networks</b>&nbsp;
                    <br />
                    <l-checkbox class="mr-4" v-model="allnetworks">All networks</l-checkbox>
                    <br />
                    <l-select2 v-if="!allnetworks" v-model="networkSelection" placeholder="Choose networks" :multiple="true" :options="networkSelectionList" :clearable="false" />

                </div>
            </div>

            <div class="flex w-full justify-between">
                <l-button type="success" @click="onSave">Save changes</l-button>
                <l-button type="danger" @click="close">Cancel</l-button>
            </div>
        </div>
    </l-modal>
</template>

<script>
    import LModal from "@/components/LModal";
    import { LInput, LButton, LSelect, LOption, LCheckbox, LSelect2 } from "@/components/forms";
    import UserManagementService from "./usermanagement.service";

    export default {
        name: "LLEdit",
        props: ["showing", "selected", "zones"],
        components: {
            LModal,
            LInput,
            LButton,
            LSelect,
            LOption,
            LCheckbox,
            LSelect2
        },
        data() {
            return {
                name: '',
                network: false,
                observations: false,
                exporting: false,
                processing: false,
                qualitycontrol: false,
                users: false,
                allnetworks: false,
                networkSelectionList: [],
                networkSelection: [],
            };
        },
        mounted() {
            this.loadInitialData();
        },
        computed: {
            editObj: function () {
                return Object.assign({}, this.selected);
            }
        },
        methods: {
            close() {
                this.$emit("close");
            },
            async onSave() {
                var group = {
                    'name': this.name, 
                    'network': this.network, 
                    'processing': this.processing, 
                    'qualitycontrol': this.qualitycontrol, 
                    'exporting': this.exporting,
                    'observations': this.observations,
                    'users': this.users, 
                    'allnetworks': this.allnetworks, 
                    'networkIds': JSON.parse(JSON.stringify(this.networkSelection)), 
                    'userIds': []
                };
                var id = await UserManagementService.addGroup(group);
                group.Id = id;
                this.$emit("afterSave", group);

                this.close();
            },
            async loadInitialData() {
                this.networkSelectionList = await UserManagementService.networks();
            },
        }
    };
</script>